/*
 ************ changeCurrency ************
 * @param currently selected currency
 * changeCurrency function will be triggered when currency is selected from dropdown.
 * There are different flows for logged-in and logged-out versions.
 *
 ************* Logged In version *************
 * Ajax call is made to update the logged-in users default currency to currently selected currency.
 * After Ajax success, event is triggered to update the listing, home or profile pages data.
 *
 ************* Logged out version *************
 * Event is triggered to update the listing, home or profile pages data.
 *
 ************* currency:change Event *************
 * currency:change Event will be listened on Home, Listing and Profile pages to update the products data according to the currently selected currency.
 * Whenever currency is changed, the prices will be hidden or shown for the products on home and listing page if they are supported in that currency and country.
 * Product profile page needs to be updated according to the currency if it is supported in that currency and country.
 * So to update the home, listing and Profile pages this event needs to be listened on these pages.
*/
'use strict';

module.exports = [
	'<script>',
	'function changeCurrency(currency) {',
	' if(window.UserInfo){',
	'   $.ajax({',
	'     url: "/api/account/v2/users/" + window.UserInfo.user_id,',
	'     type: "PATCH",',
	'     contentType: "application/json",',
	'     data: JSON.stringify({currency: currency})',
	'   }).then(function () {',
	'   document.dispatchEvent(new CustomEvent(\'currency:change\', { detail : {currency: currency}}));',
	'   })',
	' } else{',
	' document.dispatchEvent(new CustomEvent(\'currency:change\', { detail : {currency: currency}}));',
	' }',
	' document.dispatchEvent(new CustomEvent(\'universalnav:call\', { detail: { widget: \'Header\', method: \'clearStorage\' } }));',
	' $(".currency-dropdown>a").text(currency)',
	' $(".currency-dropdown .ad-component_list-item.selected").removeClass("selected")',
	' $(event.currentTarget).parent().addClass("selected")',
	'}',
	'</script>'
].join('\n');





//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/functions/currency-function.tpl.js
// module id = 33
// module chunks = 0